import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import {
  updateLedger,
  updateProduct,
} from "../../../../helpers/urlConfig/apiFunctions";
import { successToastify } from "../../../../Components/Common/Toaster";
import { getSessionData } from "../../../../helpers/sessionDetailsParser";
import errorResponseHandler from "../../../../helpers/errorResponseHandler";

function LedgerDetailsEdit({
  modal_list,
  setmodal_list,
  tog_list,
  fetchData,
  currentLedgerDetails,
}) {
  const { register, handleSubmit } = useForm({
    defaultValues: currentLedgerDetails,
  });

  const onSubmit = async (data) => {
    try {
      const body = {
        id: currentLedgerDetails.id,
        description: data.description,
        debit: data.debit,
        credit: data.credit,
        updated_by: getSessionData("user_id"),
      };

      // Replace with your API endpoint
      const response = await updateLedger(body);
      if (response.statusCode === 200) {
        successToastify("Ledger updated successfully!");
        fetchData();
        setmodal_list(false);
      } else {
        errorResponseHandler(response);
      }
    } catch (error) {
      // Handle error
      console.error("Error adding product:", error);
    }
  };

  return (
    <Modal
      isOpen={modal_list}
      toggle={() => {
        tog_list();
      }}
      centered
    >
      <ModalHeader
        className="bg-light p-3"
        toggle={() => {
          tog_list();
        }}
      >
        Edit Customer Balance
      </ModalHeader>
      <form className="tablelist-form" onSubmit={handleSubmit(onSubmit)}>
        <ModalBody>
          <div className="mb-3">
            <label htmlFor="productName" className="form-label">
              Description
            </label>
            <input
              type="text"
              id="productName"
              className="form-control"
              placeholder="Enter Description"
              {...register("description", {
                required: "Description is required",
              })}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="productName" className="form-label">
              Debit
            </label>
            <input
              type="text"
              id="debit"
              className="form-control"
              placeholder="Enter Debit"
              {...register("debit", {
                required: "Debit is required",
              })}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="productName" className="form-label">
              Credit
            </label>
            <input
              type="text"
              id="credit"
              className="form-control"
              placeholder="Enter Credit"
              {...register("credit", {
                required: "Credit is required",
              })}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="hstack gap-2 justify-content-end">
            <button
              type="button"
              className="btn btn-light"
              onClick={() => setmodal_list(false)}
            >
              Close
            </button>
            <button type="submit" className="btn btn-success" id="add-btn">
              Edit Customer Balance
            </button>
          </div>
        </ModalFooter>
      </form>
    </Modal>
  );
}

// Add prop types for validation
LedgerDetailsEdit.propTypes = {
  modal_list: PropTypes.bool.isRequired, // Indicates if the modal is open
  setmodal_list: PropTypes.func.isRequired, // Function to toggle modal visibility
  tog_list: PropTypes.func.isRequired, // Function to toggle the modal
  fetchData: PropTypes.func.isRequired, // Function to fetch updated product data
};

export default LedgerDetailsEdit;
